// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ComingSoon_wrapper__mg0_9","githubLink":"ComingSoon_githubLink__22LUk","githubIcon":"ComingSoon_githubIcon__148YZ"};